import React, { Component } from 'react';
import ReactTable from 'react-table';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import { registrationStateToString } from '../../../Utils/Converters';

class TaskRegistrationsSection extends Component {
    columns = [
        {
            header: 'Név',
            id: 'userName',
            cell: row => (
                <NavLink to={`/admin/events/${this.props.task.eventId}/tasks/${row.taskId}/registrations/${row.id}`}>{row.userName}</NavLink>
            )
        },
        {
            header: 'Kapott pont',
            accessor: 'pointValue'
        },
        {
            header: 'Állapot',
            accessor: 'state',
            cell: row => (
                <span>{registrationStateToString(row)}</span>
            )
        },
        {
            header: 'Létrehozva',
            id: 'creationDate',
            filterable: false,
            cell: row => (
                <span>
                    {new Date(row.creationDate).toLocaleString("hu")}{' '}
                    <small><em>({row.createdByUserName})</em></small>
                </span>
            )
        },
        {
            header: 'Utoljára módosítva',
            id: 'lastModificationDate',
            filterable: false,
            cell: row => {
                if (row.lastModificationDate !== null)
                    return (
                        <span>
                            {new Date(row.lastModificationDate).toLocaleString("hu")}{' '}
                            <small><em>({row.lastModifiedByUserName})</em></small>
                        </span>
                    )
                else return null;
            }
        }
    ];

    render() {
        const { registrations, task } = this.props;

        return (
            <div style={{ 'paddingLeft': '40px' }}>
                {registrations.length > 0 && <ReactTable
                    data={registrations}
                    pageSize={registrations.length}
                    columns={this.columns}
                    showPagination={false}
                />}
                {registrations.length === 0 && <p><em>Nincsenek jelentkezők.</em></p>}
                <NavLink className="btn btn-primary" to={`/admin/events/${task.eventId}/tasks/${task.id}/registrations/create`}><FontAwesomeIcon icon={faPlus} /> Új jelentkezés</NavLink>
            </div>
        )
    }
}

export default TaskRegistrationsSection;
